var slideshow = {

  retrieve: function(el) {

    if($(el).data('page') > $(el).data('lastpage') || !$(el).data('url')){
      $(el).data('retrieving', false)
      return;
    } 

    $(el).data('retrieving', true)
    const view = $(el);

    slideshow.card.attr('id', 'loading-tiles');
    slideshow.card.find('.slideshow-part-num-link').attr('href', `#`);
    slideshow.card.find('.card-img-top').attr('src', slideshow.loading.src);
    slideshow.card.find('.slideshow-part-num').text('...').addClass('alpha');
    slideshow.card.find('.slideshow-line').text('...').addClass('alpha');

    view.append(slideshow.card[0].outerHTML);

    slideshow.card.removeAttr('id');

    $.ajax({
      url: view.data('url'),
      type: 'GET',
      data: {page: view.data('page')},
      headers: {
        'Accept' : 'application/json',
      }
    })
    .done(function(data) {
      if(!data) return;
      $('#loading-tiles').remove();
      view.data('lastpage', data.lastpage);
      for (var i = 0; i < data.data.length; i++) {
        const item = data.data[i]
        slideshow.card.find('.slideshow-part-num-link').attr('href', `/${$('html').attr('lang')}/product/${item.codigo}`);
        slideshow.card.find('.card-img-top').attr('src', item.picture_url.md)
        slideshow.card.find('.slideshow-part-num').removeClass('alpha').text(item.codigo);
        slideshow.card.find('.slideshow-line').removeClass('alpha').text(item.categoria.singular);

        if(slideshow.drawHandler) slideshow.drawHandler(item, slideshow.card);

        view.append(slideshow.card[0].outerHTML);
      }

      if(slideshow.responseHandler) slideshow.responseHandler(data);

      view.data('page', view.data('page') + 1);
      view.data('retrieving', false)
    })
    .fail(function() {
    });   
  },

  goLeft: function(el) {
    if(el.data('lockbuttons')) return;
    $(el).animate({ scrollLeft: el[0].scrollLeft - el[0].offsetWidth }, 400)
  },

  goRight: function(el) {
    if(el.data('lockbuttons')) return;
    $(el).animate({ scrollLeft: el[0].scrollLeft + el[0].offsetWidth }, 400)
  },

  scroll: function(el) {
    $(el).data('lockbuttons', true);
    clearTimeout($(el).data('timer'));
    $(el).data('timer', setTimeout(function() {
      $(el).data('lockbuttons', false);
    }, 20));

    $(el).parent().find('.btn-left').toggle(el.scrollLeft > $('.slideshow-card').width());
    $(el).parent().find('.btn-right').toggle($(el).data('retrieving') || el.scrollLeft < el.scrollWidth - el.offsetWidth - $('.slideshow-card').width());

    if(el.scrollLeft > el.scrollWidth - (el.offsetWidth * 2) && !$(el).data('retrieving')) {
      slideshow.retrieve(el);
    }


  },

  init: function() {

    if($('.slideshow-content').length == 0) return;

    var canvas = document.createElement('canvas');

    var ctx = canvas.getContext('2d');
    canvas.width = 500;
    canvas.height = 334;

    ctx.fillStyle = '#e1edf2';
    ctx.fillRect(0, 0, 500, 334);

    slideshow.loading = new Image();
    slideshow.loading.src = canvas.toDataURL('image/png','');

    slideshow.card = $(document.getElementsByClassName('slideshow-card')[0].outerHTML);

    $('.slideshow-row').data('page', 2);
    $('.slideshow-row').data('lastpage', 3);

    $('.slideshow-row').scroll(function(evt) {
      evt.preventDefault();
      slideshow.scroll(this);
    });

    $('.btn-left').click(function(evt) {
      evt.preventDefault();
      slideshow.goLeft($(this).parent().find('.slideshow-row'));
    }).dblclick(function(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      $(this).parent().find('.slideshow-row').animate({ scrollLeft: 0 }, 400)
    });;

    $('.btn-right').click(function(evt) {
      evt.preventDefault();
      slideshow.goRight($(this).parent().find('.slideshow-row'));
    });

    $(window).resize(function() {
      document.getElementsByClassName('slideshow-row')[0].scrollTo(0,0);
    });
  }

};

slideshow.init();

module.exports = {

  onResponse: function(handler) {
    slideshow.responseHandler = handler;
  },

  onDraw: function(handler) {
    slideshow.drawHandler = handler;
  }
}